// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkFollowPreview-cls1_Atn","cls2":"BulkFollowPreview-cls2_gOS BulkFollowPreview-cls1_Atn","compact":"BulkFollowPreview-compact_wkI"};